import { render, staticRenderFns } from "./SeverityToggle.vue?vue&type=template&id=ccfe0960&scoped=true&"
import script from "./SeverityToggle.vue?vue&type=script&lang=js&"
export * from "./SeverityToggle.vue?vue&type=script&lang=js&"
import style0 from "./SeverityToggle.vue?vue&type=style&index=0&id=ccfe0960&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfe0960",
  null
  
)

export default component.exports